module.exports = __webpack_public_path__ + "img/06-4.a8c5f802.png";